import React from 'react'
import { Link } from 'react-router-dom'
import { Badge, Button, Card, CardBody, CardFooter } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faEdit, faEyeSlash, faImage, faPause, faPlay, faTrashAlt, faTruck } from '@fortawesome/free-solid-svg-icons'
import {
  SERVICE_STATUS,
  categoryIcon,
  formatAvailability,
  formatPriceRange,
  formatVisitFee,
  pricingModeShort,
  storageUrl
} from '../../marketplaceConstants'

const ProviderServiceCard = ({ service, busy, onToggleStatus, onDelete }) => {
  const status = SERVICE_STATUS[service.status] || SERVICE_STATUS.active
  const cover = service.photos?.[0]
  const isActive = service.status === 'active'

  return (
    <Card className="h-100 overflow-hidden">
      <div className="position-relative bg-200" style={{ height: 170 }}>
        {cover ? (
          <img src={storageUrl(cover.path)} alt={service.title} className="w-100 h-100" style={{ objectFit: 'cover', opacity: isActive ? 1 : 0.55 }} />
        ) : (
          <div className="h-100 d-flex align-items-center justify-content-center text-400">
            <FontAwesomeIcon icon={faImage} size="2x" />
          </div>
        )}
        <Badge color={status.color} pill className="position-absolute" style={{ top: 12, left: 12 }}>
          {status.label}
        </Badge>
        {service.photos?.length > 1 && (
          <Badge color="dark" pill className="position-absolute" style={{ bottom: 12, right: 12, opacity: 0.85 }}>
            <FontAwesomeIcon icon={faImage} className="mr-1" />
            {service.photos.length}
          </Badge>
        )}
      </div>
      <CardBody className="d-flex flex-column">
        <p className="fs--1 text-primary font-weight-semi-bold mb-1">
          <FontAwesomeIcon icon={categoryIcon(service.category)} className="mr-1" />
          {service.category?.name}
        </p>
        <h5 className="fs-0 mb-2">{service.title}</h5>
        <p className="mb-1">
          <span className="font-weight-bold text-900">{formatPriceRange(service.price_min, service.price_max)}</span>
          <span className="fs--1 text-600 ml-1">{pricingModeShort(service.pricing_mode)}</span>
        </p>
        <p className="fs--1 text-700 mb-1">
          <FontAwesomeIcon icon={faTruck} className="text-500 mr-2" />
          {formatVisitFee(service)}
        </p>
        <p className="fs--1 text-700 mb-0">
          <FontAwesomeIcon icon={faCalendarAlt} className="text-500 mr-2" />
          {formatAvailability(service.available_days, service.available_from, service.available_to)}
        </p>
        {isActive && !service.is_visible && (
          <p className="fs--2 text-warning mb-0 mt-auto pt-2">
            <FontAwesomeIcon icon={faEyeSlash} className="mr-1" />
            Se mostrará en el Marketplace cuando aprobemos tu perfil.
          </p>
        )}
        {!isActive && (
          <p className="fs--2 text-600 mb-0 mt-auto pt-2">
            <FontAwesomeIcon icon={faEyeSlash} className="mr-1" />
            Pausado: los propietarios no lo ven.
          </p>
        )}
      </CardBody>
      <CardFooter className="bg-light d-flex align-items-center py-2" style={{ gap: 8 }}>
        <Button tag={Link} to={`/provider/services/${service.id}/edit`} color="falcon-default" size="sm" className="text-nowrap" disabled={busy}>
          <FontAwesomeIcon icon={faEdit} className="mr-1" />
          Editar
        </Button>
        <Button color="falcon-default" size="sm" className="text-nowrap" disabled={busy} onClick={() => onToggleStatus(service)}>
          <FontAwesomeIcon icon={isActive ? faPause : faPlay} className="mr-1" />
          {isActive ? 'Pausar' : 'Reanudar'}
        </Button>
        <Button color="link" size="sm" className="text-danger ml-auto px-1" disabled={busy} onClick={() => onDelete(service)} title="Eliminar servicio">
          <FontAwesomeIcon icon={faTrashAlt} />
        </Button>
      </CardFooter>
    </Card>
  )
}

export default ProviderServiceCard
